import useBoolean from './useToggle';
export default useBoolean;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useBoolean.js
// module id = UPEC
// module chunks = 0